module.exports = __webpack_public_path__ + "img/ReportingMetrics.07588375.jpg";